import { motion } from 'framer-motion'
import React, { useState } from 'react'
import styled from 'styled-components'
import Link from 'next/link'

import { media } from '../../utils/style-utils'

import DotArrow from './DotArrow'

const CARD_VARIANTS = {
	hover: {
		scale: 1.03,
		transition: { duration: 0.1, ease: 'easeInOut' },
	},
	tap: {
		scale: 0.97,
		transition: { duration: 0.1, ease: 'easeInOut' },
	},
}

function LinkCard({ item }) {
	const [isHovered, setHovered] = useState(false)

	return (
		<LinkWrapper href={item.link.url}>
			<Card
				whileTap='tap'
				whileHover='hover'
				onMouseEnter={() => setHovered(true)}
				onMouseLeave={() => setHovered(false)}
				variants={CARD_VARIANTS}
			>
				<ItemTitle>{item.title}</ItemTitle>
				<IconWrapper>
					<DotArrow
						isHovered={isHovered}
						backgroundColor={'var(--deep-blue)'}
					/>
				</IconWrapper>
			</Card>
		</LinkWrapper>
	)
}

export default LinkCard

const LinkWrapper = styled(Link)`
	display: flex;
	flex: 1 0 calc(33.33% - 24px);
	min-width: calc(33.33% - 24px);

	${media.tablet`
		min-width: unset;
		flex: 1 0 100%;
	`}
`

const Card = styled(motion.div)`
	border-radius: 56px;
	height: 240px;
	background: white;
	flex: 1 0 calc(33.33% - 24px);
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-block: var(--spacer-base);
	padding-inline: var(--spacer-lg) var(--spacer-xs);

	cursor: pointer;

	&:hover {
		background: var(--blue-100);
		box-shadow: 0px 4px 12px -6px rgba(0, 0, 0, 0.15);
	}

	&:focus-visible {
		outline: 3px solid var(--orange);
		outline-offset: 1px;
	}

	transition: var(--animation-transition);

	${media.desktopSm`
		padding-left: var(--spacer-md);
	`};
	${media.phone`
		min-width: unset;
		height: 128px;
		padding-left: var(--spacer-md);
	`}
`

const ItemTitle = styled.h3`
	font-size: clamp(1.5rem, 1vw + 0.05rem, 3.5rem);
`

const IconWrapper = styled.div`
	height: 32px;
	width: 32px;
`
